export default "__VITE_ASSET__5BlbbLIE__"